jQuery(document).ready(function () {
    if (typeof _paq !== 'undefined') {
        jQuery('.navbar-nav').on('click', 'a:not(.dropdown-toggle)', function(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                _paq.push(['trackEvent', 'TestEvents', 'MenuClickMobile', window.location.href]);
            } else {
                _paq.push(['trackEvent', 'TestEvents', 'MenuClickDesktop', window.location.href]);
            }
        });

        jQuery('.search-field').on('focus', function(){
            _paq.push(['trackEvent', 'TestEvents', 'SearchFocus', window.location.href]);
        });

        jQuery('.tocList').on('click', 'a', function() {
            _paq.push(['trackEvent', 'TestEvents', 'TocClick', window.location.href]);
        });

        jQuery('.rassen-navigation--bottom').on('click', 'a', function() {
            _paq.push(['trackEvent', 'TestEvents', 'rassen-navigation--bottomClick', window.location.href]);
        });

        jQuery('.rassen-navigation--top').on('click', 'a', function() {
            _paq.push(['trackEvent', 'TestEvents', 'rassen-navigation--topClick', window.location.href]);
        });

        jQuery('.sidebar-toc-wrapper .list-group-item').on('click', 'a', function(e) {
            console.log(e.target);
            _paq.push(['trackEvent', 'TestEvents', 'sticky-sidebar-link-click', jQuery(e.target).text()]);
        });
    }
});
